module.exports = __webpack_public_path__ + "img/logo.d0f0233f.png";